import { useTheme } from "@mui/material";
// Legacy Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  Button,
  CircleQuestionMarkIcon,
  HeadphoneIcon,
  LeftArrowIcon,
  VideoCameraIcon,
} from "components";
import {
  useCreateSampleData,
  useGlobalStore,
  usePermissionStore,
} from "controller";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { PERMISSIONS } from "shared";
import { ChatNotificationButton } from "shared/features/chat-notification/ChatNotificationButton";
import { NotificationButton } from "shared/features/notification-v2/NotificationButton";
import { openBookADemo } from "utilz/helpers";
// HOC Imports
import { MeetAiBanner } from "./meet-ai-banner/MeetAiBanner";
import { NewButton } from "./new-button/NewButton";
import { TopBarProfileButton } from "./top-bar-profile-button";
import { TrialBanner } from "./trial-banner/TrialBanner";
import { WatchListButton } from "./WatchListButton";

const TopBarComponent = ({
  enableReturn = false,
}: {
  enableReturn?: boolean;
}) => {
  const theme = useTheme();
  const trialPeriodEndDate = useGlobalStore((state) => state.trialEndDate);
  const sampleDataStatus = useGlobalStore((state) => state.sampleDataStatus);
  const { mutateAsync: createSampleData, isLoading: isCreateLoading } =
    useCreateSampleData();

  const isSuperAdmin = usePermissionStore((state) => state.isSuperAdmin());

  const setSampleDataStatus = useGlobalStore(
    (state) => state.setSampleDataStatus,
  );

  const havePermissionForAnyServiceType = usePermissionStore((state) =>
    state.hasPermissions(
      [
        PERMISSIONS.SD.SD_TICKET_ALL_RW,
        PERMISSIONS.SD.SD_TICKET_ASSIGNED_RW,
        PERMISSIONS.SD.SD_PROJECT_ALL_RW,
        PERMISSIONS.SD.SD_PROJECT_ASSIGNED_RW,
        PERMISSIONS.SD.SD_TASK_ALL_RW,
        PERMISSIONS.SD.SD_TASK_ASSIGNED_RW,
      ],
      "OR",
    ),
  );

  const navigate = useNavigate();
  const location = useLocation();
  const role = useGlobalStore((state) => state?.role);

  // const isArchivePage = document.location.href.split("/").includes("archive");
  const isControlCenterPage = document.location.href
    .split("/")
    .includes("control-center");

  const handleButtonClick = async () => {
    try {
      await createSampleData({});
      toast.success("Sample data is being loaded and will be available soon");
      setSampleDataStatus("processed");
    } catch (error) {
      console.log(error);
      toast.error("Failed to add sample data");
    }
  };

  // Renderer
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          flexGrow: 1,
          px: "8px",

          overflow: "scroll",
          "&:: -webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack direction="row" spacing={"16px"}>
            {/* <MenuIconButton /> */}

            <Box
              component="button"
              onClick={() => {
                if (location.key === "default") return;
                if (
                  location.pathname.includes(
                    "/app/customers/customers/profile/",
                  )
                ) {
                  navigate("/app/customers/customers/home");
                } else if (
                  location.pathname.includes("/app/customers/users/profile/")
                ) {
                  navigate("/app/customers/users/home");
                } else {
                  navigate(-1);
                }
              }}
              sx={{
                ml: "20px",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                aspectRatio: "1",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "transparent",
                border: "1px solid #CCCCCC",
                "&:hover": {
                  cursor: location.key === "default" ? "default" : "pointer",
                },
              }}
            >
              <LeftArrowIcon
                sx={{
                  color: location.key === "default" ? "#CCCCCC" : "#1C1E26",
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <SizableTextField
                name={""}
                label={""}
                value={""}
                adornment={true}
                adornmentPosition={"start"}
                adornmentValue={"search"}
                disabled={true}
                required={true}
                error={false}
                helperText={""}
                placeholder={"Search"}
                size={"small"}
                changeHandler={() => {}}
              /> */}
            </Box>
          </Stack>
          <Stack direction="row" spacing={"0px"}>
            {/* <Button
              className="intercomV2-topAppBar-bookDemoBtn"
              startIcon={
                <VideoCameraIcon sx={{ width: "24px", height: "24px" }} />
              }
              onClick={openBookADemo}
              variant="ghost"
              sx={{ color: theme.palette.lightBg.high }}
            >
              Book a demo
            </Button> */}
            <Button
              className="intercomV2-topAppBar-howToBtn"
              startIcon={
                <CircleQuestionMarkIcon
                  sx={{ width: "24px", height: "24px" }}
                />
              }
              onClick={() => {
                navigate("how-to");
              }}
              variant="ghost"
              sx={{ color: theme.palette.lightBg.high }}
            >
              How to
            </Button>
            <Button
              className="intercomV2-topAppBar-supportBtn"
              startIcon={
                <HeadphoneIcon sx={{ width: "20px", height: "20px" }} />
              }
              onClick={() => {
                // @ts-ignore
                window.Intercom("show");
              }}
              variant="ghost"
              sx={{ color: theme.palette.lightBg.high }}
            >
              Support
            </Button>
            {havePermissionForAnyServiceType && <WatchListButton />}
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack
            direction="row"
            spacing={"16px"}
            mr={"24px"}
            alignItems={"center"}
          >
            <TrialBanner />
            <MeetAiBanner />
            <NewButton />
            {/* {isSuperAdmin &&
              sampleDataStatus === "skipped" &&
              location.pathname === "/app/control-center" &&
              dayjs().isBefore(trialPeriodEndDate) && (
                <Button
                  variant="secondary"
                  onClick={() => handleButtonClick()}
                  loading={isCreateLoading}
                >
                  Add sample data
                </Button>
              )}
            <ClearSampleDataButton /> */}
            {
              havePermissionForAnyServiceType && <ChatNotificationButton />

              // <ChatNotification />
            }
            {havePermissionForAnyServiceType && <NotificationButton />}

            <TopBarProfileButton
              status={true}
              // imgurl='https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250'
            />
            {/* <CustomIconButton
              icon="plus"
              onClick={() => {
                setCreateNewDialogState(true);
              }}
            /> */}
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default TopBarComponent;
